import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Button from "../../Utils/Button/index";
import { Link } from "react-router-dom";

export const Renderslickslider = (props) => {
  return (
    <Carousel
      showThumbs={false}
      showIndicators={props.showDots}
      onChange={(i) => props.handleSlideChange(i)}
    >
      {props.sliderData.map((getSliderData, index) => {
        return getSliderData.sliderHeading === "# 1" ? (
          <div className="slides" key={index}>
            <h1 className="black-color-step">{getSliderData.sliderStep}</h1>
            <h1 style={{ color: "#ff6600" }}>{getSliderData.sliderHeading}</h1>
            <img
              src={getSliderData.sliderImage}
              alt="Slide 1 Image"
              className="steps-image"
            />
            <h1 style={{ color: "#333333" }}>
              {getSliderData.sliderParagraph}
            </h1>
            <Link
              to={{
                pathname: props.startLink,
              }}
            >
              <p className="skip">Skip</p>
            </Link>
          </div>
        ) : getSliderData.sliderHeading === "# 2" ? (
          <div className="slides" key={index}>
            <h1 className="black-color-step">{getSliderData.sliderStep}</h1>
            <h1 style={{ color: "#ff6600" }}>{getSliderData.sliderHeading}</h1>
            <img
              src={getSliderData.sliderImage}
              alt="Slide 1 Image"
              className="steps-image"
            />
            <h1 style={{ color: "#333333" }}>
              {getSliderData.sliderParagraph}
            </h1>
            <Link
              to={{
                pathname: props.startLink,
              }}
            >
              <p className="skip">Skip</p>
            </Link>
          </div>
        ) : getSliderData.sliderHeading === "# 3" ? (
          <div className="slides" key={index}>
            <h1 className="black-color-step">{getSliderData.sliderStep}</h1>
            <h1 style={{ color: "#ff6600" }}>{getSliderData.sliderHeading}</h1>
            <img
              src={getSliderData.sliderImage}
              alt="Slide 1 Image"
              className="steps-image"
            />
            <h1 style={{ color: "#333333" }}>
              {getSliderData.sliderParagraph}
            </h1>
            <Button type="start" style={{ width: "70%" }}>
              <Link
                to={{
                  pathname: props.startLink,
                }}
              >
                BEGIN QUESTIONNAIRE
              </Link>
            </Button>
          </div>
        ) : (
          <div className="slides" key={index}>
          <h1 className="steps">{getSliderData.sliderStep}</h1>
          <img
            src={getSliderData.sliderImage}
            alt="Slide 1 Image"
            style={{ width: "40%" }}
          />
          {props.assessmentType == "invitations" ? (
            <h1>
              <span style={{ paddingRight: ".2em", textTransform: "capitalize" }}>
                {props.invitationDetails &&
                  props.invitationDetails.user_assessment__participant__full_name + "'s"}
              </span>
              Assessment
            </h1>
          ) : (
            <h1>{getSliderData.sliderHeading}</h1>
          )}
          {props.assessmentType == "invitations" && props.slideIndex == 0 ? (
            <p>
              Assess
              <span
                style={{
                  padding: "0 5px 0 5px",
                  textTransform: "capitalize",
                  fontWeight: "bold",
                }}
              >
                {props.invitationDetails &&
                  props.invitationDetails.user_assessment__participant__full_name}
              </span>
              's assessment by responding to a set of 30 questions. Allow yourself 4-5
              minutes and bingo, you're done!
            </p>
          ) : (
            <p>{getSliderData.sliderParagraph}</p>
          )}
        </div>
        );
      })}
    </Carousel>
  );
};



// WEBPACK FOOTER //
// ./src/new/Components/Self-assessment/popover-slick-slider.jsx